export default class Panel {
	constructor(elementId, showDebug = false) {
		this.showDebug = showDebug;
		if (this.showDebug) console.group(`constructor("${elementId}", showDebug=${showDebug})`);
		this.panel = document.getElementById(elementId);
		this.openButtons = this.getButtonElements(elementId, 'Open');
		this.closeButtons = this.getButtonElements(elementId, 'Close');

		// Open panel if URL hash matches
		if (this.shouldOpenPanelFromHash(elementId)) {
			console.log(`URL has hash for ${elementId} panel; opening.`);
			this.openPanel();
		}

		this.openButtons.forEach(button => {
			button.addEventListener('click', (event) => this.openPanel(event) );
		});
		this.closeButtons.forEach(button => {
			button.addEventListener('click', () => this.closePanel() );
		});

		// Handle closing on backdrop click (optional)
		this.panel.addEventListener('click', (event) => {
			if (event.target.nodeName === 'DIALOG') {
				this.closePanel();
			}
		});
		if (this.showDebug) console.groupEnd();
	}

	shouldOpenPanelFromHash(panelId) {
		if (this.showDebug) console.group(`shouldOpenPanelFromHash("${panelId}")`);
		const hash = window.location.hash.slice(1); // Remove leading "#"
		if (this.showDebug) console.info(`Hash: "${hash}"`);
		if (this.showDebug) console.groupEnd();
		return hash === panelId;
	}

	getButtonElements(panelId, buttonType) {
		if (this.showDebug) console.group(`getButtonElements("${panelId}", "${buttonType}")`);
		let buttons = null;
		const baseSelector = `.js${buttonType}Panel`;
		if (this.showDebug) console.info({baseSelector});
		if (buttonType == 'Open') {
			// Can be anywhere; global selector
			const selector = `${baseSelector}[data-panel-id="${panelId}"]`;
			buttons = document.querySelectorAll(selector);
		} else {
			// Must be within the <dialog>; scoped selector
			buttons = this.panel.querySelectorAll(baseSelector);
		}
		if (this.showDebug) console.info({buttons});
		if (this.showDebug) console.groupEnd();
		return buttons;
	}

	openPanel(event) {
		if (this.showDebug) console.group(`openPanel(${event})`);
		if (this.showDebug) console.info(`Opening panel #${this.panel.id}`);
		event ? event.preventDefault() : null;
		this.panel.classList.add('panel--opening');
		setTimeout(() => {
			this.panel.showModal();
		}, 100);
		setTimeout(() => {
			this.panel.querySelector("input")?.focus(); // optional chaining FTW
			this.panel.classList.remove('panel--opening');
		}, 800);
		if (this.showDebug) console.groupEnd();
	}

	closePanel() {
		if (this.showDebug) console.group(`closePanel()`);
		if (this.showDebug) console.info(`Closing panel #${this.panel.id}`);
		this.panel.classList.add('panel--closing');
		setTimeout(() => {
			this.panel.close();
			this.panel.classList.remove('panel--closing');
		}, 100);
		if (this.showDebug) console.groupEnd();
	}
}